import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ru from 'vuetify/lib/locale/ru'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { ru },
    current: localStorage.getItem('lang') || 'en'
  },
  theme: {
    themes: {
      light: {
        primary: '#8bc34a',
        secondary: '#03a9f4',
        accent: '#2196f3',
        error: '#ff5722',
        warning: '#ff9800',
        info: '#00bcd4',
        success: '#4caf50'
      }
    }
  }
})

export default vuetify
